<template lang='pug'>
  .search-results
    template(v-if='articlesLoading')
      .articles-loader
        .loader-spinner

    template(v-else)
      .article(v-for='article in results')
        .row(@click='gotoArticle(article)')
          .col-12
            p(v-html='highlightQuery(article.name)')
        .article-line
</template>

<script>
import UrlMixin from './url-mixin'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('faq')

export default {
  computed: {
    ...mapGetters(['objectBySlug']),
    ...mapState([
      'results',
      'sections',
      'searchQuery',
      'articlesLoading'
    ])
  },

  methods: {
    ...mapMutations([
      'setSearchQuery',
      'setFocusSearch',
      'setResults'
    ]),

    ...mapActions(['closeSearch']),

    gotoArticle (article) {
      this.setSearchQuery('')
      this.setFocusSearch(false)
      this.setResults([])

      this.$router.push({ name: 'faq-article-show',
        params: {
          sectionId: UrlMixin.getSlug(this.objectBySlug('sections', String(article.section_id))),
          articleId: UrlMixin.getSlug(article) }
      })
    },

    highlightQuery (text) {
      const content = text.replace(/ /g, '&nbsp;')
      let highlighted = this.searchQuery

      for (const word of text.split(' ')) {
        if (word.toLowerCase().indexOf(highlighted) === 0) {
          highlighted = highlighted.charAt(0).toUpperCase() + highlighted.slice(1)
        }
      }
      return content.replace(new RegExp(this.searchQuery, 'ig'), `<span class="highlighted">${highlighted}</span>`)
    }
  }
}
</script>

<style lang='scss'>
  .highlighted {
    color: $brand-primary;
  }
</style>

<style lang='scss' scoped>
  .search-results {
    min-height: 60px;
    width: 510px;
    margin: -1px auto;
    position: relative;
    border: 1px solid $grey-mid;
    background-color: $white;
    z-index: 1000;

    @include media-breakpoint-down(md) {
      width: 300px;
    }

    .articles-loader {
      display: flex;
      justify-content: center;
      padding-top: 10px;
    }

    .loader-spinner {
      height: 40px;
      width: 40px;
    }

    .row {
      cursor: pointer;
      margin-top: 17px;
      margin-left: 5px;
    }

    .article-line {
      height: 1px;
      margin-top: 8px;
      background-color: $grey;
    }

    p {
      word-wrap: break-word;
    }
  }
</style>
